import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Paper, Stack, Typography } from '@mui/material';
import { Scrollbar } from 'app/components';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const MapTransportBroadcastEventList = function (props) {
  const { checkedItem, onChangePlayTime } = props;
  const { events } = useSelector((state) => state.map.transportSelectedItem.broadcast);
  const [expanded, setExpanded] = useState(false);

  const handleChangeAccordion = (panel, time) => (event, isExpanded) => {
    if (isExpanded) {
      onChangePlayTime(moment(time).diff(moment(time).startOf('day'), 'seconds'));
    }

    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    setExpanded(checkedItem);
  }, [checkedItem]);

  return (
    <Stack
      sx={(theme) => ({
        width: '100%',
        height: '100%',
        '.MuiPaper-elevation:first-of-type': {
          border: 'none',
        },
        '.MuiAccordion-root': {
          boxShadow: 'none',
          borderRadius: '0',
          transition: 'background-color ' + theme.transitions.duration.shortest + 'ms ' + theme.transitions.easing.easeInOut + ' 0ms',
          '&:before': {
            display: 'none',
          },
          '&.Mui-expanded': {
            margin: '0',
          },
          '.MuiAccordionSummary-expandIconWrapper': {
            svg: {
              fontSize: '18px',
            },
          },
        },
        '.MuiAccordionDetails-root': {
          padding: theme.spacing(1, 2),
          '.MuiPaper-root': {
            position: 'relative',
            border: 'none',
            '.MuiPaper-row': {
              display: 'grid',
              gap: 1,
              gridTemplateColumns: 'repeat(7, 1fr)',
              '&:nth-of-type(2) .MuiTypography-root:last-of-type': {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              },
              '.MuiTypography-root:first-of-type': {
                color: 'text.secondary',
              },
            },
            '.MuiPaper-row .MuiTypography-root:first-of-type': {
              gridRow: '1',
              gridColumn: '1/3',
            },
            '.MuiPaper-row .MuiTypography-root:last-of-type': {
              gridRow: '1',
              gridColumn: '3/8',
              'span:nth-of-type(2)': {
                paddingLeft: theme.spacing(0.5),
              },
            },
          },
        },
        '.MuiAccordionSummary-root': {
          padding: theme.spacing(0, 2),
          minHeight: '24px',
          transition: 'none',
          background: 'none',
          borderRadius: '0',
          '&:hover': {
            bgcolor: 'background.default',
            borderRadius: '0',
          },
          '&.Mui-expanded': {
            minHeight: '24px',
            bgcolor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            borderRadius: '0',
            '.MuiAccordionSummary-expandIconWrapper': {
              color: '#FFFFFF',
            },
          },
        },
        '.MuiAccordionSummary-content': {
          alignItems: 'center',
          overflow: 'hidden',
          margin: theme.spacing(0),
          '&.Mui-expanded': {
            margin: theme.spacing(0),
          },
          '.MuiTypography-root:first-of-type': {
            paddingRight: theme.spacing(1),
          },
          '.MuiTypography-root:last-of-type': {
            paddingLeft: theme.spacing(2),
          },
        },
      })}>
      <Scrollbar>
        {events.map((value, key) => (
          <Accordion key={key} expanded={expanded === value.alarmid} onChange={handleChangeAccordion(value.alarmid, value.time)}>
            <AccordionSummary disableRipple expandIcon={<ExpandMore />}>
              <Typography component='span'>{moment(value.time).format('DD.MM')}</Typography>
              <Typography component='span'>{moment(value.time).format('HH:mm:ss')}</Typography>
              <Typography component='span'>
                Состояние {value.type} - {config.mapBroadcastEventsDescription[value.type]}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Paper variant='outlined'>
                <Stack className='MuiPaper-row'>
                  <Typography variant='body1'>Местоположение</Typography>
                  <Typography variant='body1'>
                    {value.gpslat}, {value.gpslng}
                  </Typography>
                </Stack>
                <Stack className='MuiPaper-row'>
                  <Typography variant='body1'>Скорость</Typography>
                  <Typography variant='body1'>
                    {value.speed} {config.conditions.speed.unit}
                  </Typography>
                </Stack>
                <Stack className='MuiPaper-row'>
                  <Typography variant='body1'>Высота</Typography>
                  <Typography variant='body1'>
                    {value.altitude} {config.conditions.height.unit}
                  </Typography>
                </Stack>
                <Stack className='MuiPaper-row'>
                  <Typography variant='body1'>Направление</Typography>
                  <Typography variant='body1'>
                    {value.direction} {config.conditions.course.unit}
                  </Typography>
                </Stack>
              </Paper>
            </AccordionDetails>
          </Accordion>
        ))}
      </Scrollbar>
    </Stack>
  );
};

export default MapTransportBroadcastEventList;
